export class PerformanceRiskAnalysis {
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public returns: any;
  public volatility: any;
  public sharpe_ratio: any;
  public maximum_drawdown: any;
  public cornish_fisher_5pct: any;
  public calmar_ratio: any;
  public yearly_returns: any;
  public excess_returns: any;
  public tracking_error: any;
  public information_ratio: any;
  public maximum_relative_drawdown: any;
  public market_exposure: any;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date              = data.creation_date ? new Date(data.creation_date) : this.creation_date;
    this.inception_date             = data.inception_date ? new Date(data.inception_date) : this.inception_date;
    this.last_date                  = data.last_date ? new Date(data.last_date) : this.last_date;

    this.returns                    = data.returns ? data.returns : this.returns;
    this.volatility                 = data.volatility ? data.volatility : this.volatility;
    this.sharpe_ratio               = data.sharpe_ratio ? data.sharpe_ratio : this.sharpe_ratio;
    this.maximum_drawdown           = data.maximum_drawdown ? data.maximum_drawdown : this.maximum_drawdown;
    this.cornish_fisher_5pct        = data.cornish_fisher_5pct ? data.cornish_fisher_5pct : this.cornish_fisher_5pct;
    this.calmar_ratio               = data.calmar_ratio ? data.calmar_ratio : this.calmar_ratio;
    this.yearly_returns             = data.yearly_returns ? data.yearly_returns : this.yearly_returns;
    this.excess_returns             = data.excess_returns ? data.excess_returns : this.excess_returns;
    this.tracking_error             = data.tracking_error ? data.tracking_error : this.tracking_error;
    this.information_ratio          = data.information_ratio ? data.information_ratio : this.information_ratio;
    this.maximum_relative_drawdown  = data.maximum_relative_drawdown ? data.maximum_relative_drawdown : this.maximum_relative_drawdown;
    this.market_exposure            = data.market_exposure ? data.market_exposure : this.market_exposure;
  }
}
